import * as React from 'react';
import { GetOSSUri } from '../common/ApiHelper';

interface IAsyncImgProps {
    src: string;
    style?: React.CSSProperties;
}

class AsyncImgComponent extends React.PureComponent<IAsyncImgProps> {
    // public state = {
    //     src: ''
    // }
    // public componentDidMount() {
    //     // console.log('componentDidMount', this.props);
    //     this.Update(this.props);
    // }
    // public componentWillUpdate(nextProps: IAsyncImgProps, nextState: { src: string }) {
    //     if (nextProps.src !== this.props.src) {
    //         // console.log('componentWillUpdate', nextProps, nextState, this.props, this.state);
    //         this.Update(nextProps);
    //     }
    // }
    // public Update = (props: IAsyncImgProps) => {
    //     const { src } = props;
    //     if (src.indexOf('http') < 0) {
    //         GetOSSUri(src).then((v: { uri: string })=>{
    //             // console.log(v);
    //             this.setState({src: v.uri});
    //         })
    //     }
    //     else {
    //         this.setState({src: src});
    //     }
    // }
    // public onError = () => {
    //     this.setState({src: ''});
    // }
    public render() {
        const { src } = this.props;
        let src1="";
        if(src.indexOf("//")!=-1){
            src1=src.substring(1,src.length);
        }else{
            src1=src;
        }
        return (
            <img style={this.props.style} src={src1}/>
        );
    }
}

export default AsyncImgComponent;